import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlug, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { IPaginated } from "src/types/paginated";
import { IPharmaInventory, IqueryParams } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import QueryString from "qs";
import defaultImage from "src/assets/images/emty-img.png";
import { CURRENCY, ImageBaseUrl } from "src/lib/constans";

const PrintProduct = ({
  product,
  index,
  onRemove,
}: {
  product: any;
  index: number;
  onRemove: () => void;
}) => {
  return (
    <div className="w-full flex gap-2">
      <div className="w-[70px] aspect-[1/0.9] overflow-hidden rounded-lg border border-gray-300">
        <img
          src={`${ImageBaseUrl}${product?.images}`}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-2 justify-center w-[calc(100%-80px)]">
        <div className="flex items-center gap-2 justify-between">
          <p className="font-Poppins-Regular truncate font-size-16px theme-color-green">
            {product?.productName}
          </p>
          <button
            title="Remove product"
            className="w-[23px] cursor-pointer h-[23px] hover:bg-red-200 transition-all duration-300 border border-red-500 rounded flex items-center justify-center"
            onClick={onRemove}
          >
            <FontAwesomeIcon
              icon={faTrash}
              className="font-size-12px text-red-500"
            />
          </button>
        </div>
        <div className="font-Poppins-Medium flex justify-between -mt-[5px] font-size-14px theme-color-gray">
          <p>
            {CURRENCY}{" "}
            {parseFloat(
              product?.salePrice || product?.regularPrice || "0"
            ).toFixed(2)}
          </p>
          <p>Quantity: {String(product?.quantity || 1).padStart(2, "0")}</p>
        </div>
      </div>
    </div>
  );
};

interface IResponce {
  documents: IPharmaInventory[];
  paginated: IPaginated;
}

interface IProps {
  payload: any;
  setPayload: (payload: any) => void;
  setActiveTab: (tab: string) => void;
  allProducts: IPharmaInventory[];
  productQuantity: {
    [key: string]: number;
  };
  paginated: IPaginated;
  queryParams: IqueryParams;
  setQueryParams: (queryParams: IqueryParams) => void;
  handleChangeText: (text: string) => void;
  handlePageChange: (page: number) => void;
  productLoader: boolean;
  setProductQuantity: (productQuantity: any) => void;
  allPharmaProducts: IPharmaInventory[];
  checkProducts: () => boolean;
}

const OrderAddProduct = ({
  payload,
  setPayload,
  setActiveTab,
  allProducts,
  productQuantity,
  paginated,
  queryParams,
  setQueryParams,
  handleChangeText,
  handlePageChange,
  productLoader,
  setProductQuantity,
  allPharmaProducts,
  checkProducts,
}: IProps) => {
  return (
    <>
      <div className="w-full flex gap-2 border-b border-gray-300 mb-5 pb-5">
        <div className="w-[60%] bg-[#F6FBFF] rounded-lg p-3 h-[430px] overflow-y-auto">
          <h2 className="font-Poppins-SemiBold font-size-18px mb-2 theme-color-green">
            Products
          </h2>
          <div className="flex flex-col gap-4">
            {payload.products.length > 0 ? (
              payload.products.map((product: any, index: number) => (
                <PrintProduct
                  key={index}
                  product={{
                    ...allPharmaProducts.find(
                      (item: IPharmaInventory) => item._id === product
                    ),
                    quantity: productQuantity[product],
                  }}
                  index={index}
                  onRemove={() => {
                    setPayload((prev: any) => ({
                      ...prev,
                      products: prev.products.filter((p: any) => p !== product),
                    }));
                  }}
                />
              ))
            ) : (
              <div className="w-full h-[100px] flex items-center justify-center">
                <p className="font-Poppins-Regular font-size-16px theme-color-gray">
                  No products added
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="w-[40%] h-fit bg-[#F6FBFF] rounded-lg p-3">
          <h2 className="font-Poppins-SemiBold font-size-18px mb-2 theme-color-green">
            Order Details
          </h2>
          <div className="flex list-none flex-col gap-2">
            <li className="flex justify-between font-Poppins-Regular font-size-15px theme-color-gray">
              <p>Order Total</p>
              <p className="theme-color-green text-end">
                {CURRENCY}{" "}
                {payload.products
                  .map((product: any) =>
                    allPharmaProducts.find(
                      (item: IPharmaInventory) => item._id === product
                    )
                  )
                  .reduce(
                    (acc: number, curr: any) =>
                      acc +
                      parseFloat(curr?.salePrice || curr?.regularPrice || "0") *
                        (productQuantity[curr?._id] || 1),
                    0
                  )
                  .toFixed(2)}
              </p>
            </li>
            {/* <li className="flex justify-between font-Poppins-Regular font-size-15px theme-color-gray">
              <p>Discount</p>
              <p className="theme-color-green text-end">{CURRENCY} 124.95</p>
            </li> */}
            <li className="flex justify-between font-Poppins-Regular font-size-15px theme-color-gray">
              <p>Shipping</p>
              <p className="theme-color-green text-end">{CURRENCY} 0.00</p>
            </li>
            {/* <li className="flex justify-between font-Poppins-Regular font-size-15px theme-color-gray">
              <p>Estimate VAT</p>
              <p className="theme-color-green text-end">{CURRENCY} 124.95</p>
            </li> */}
            <li className="flex justify-between font-Poppins-Medium font-size-16px theme-color-green">
              <p>Total Amount</p>
              <p className="theme-color-green text-end">
                {CURRENCY}{" "}
                {payload.products
                  .map((product: any) =>
                    allPharmaProducts.find(
                      (item: IPharmaInventory) => item._id === product
                    )
                  )
                  .reduce(
                    (acc: number, curr: any) =>
                      acc +
                      parseFloat(curr?.salePrice || curr?.regularPrice || "0") *
                        (productQuantity[curr?._id] || 1),
                    0
                  )
                  .toFixed(2)}
              </p>
            </li>
          </div>
        </div>
      </div>
      <div className="w-full">
        <SearchFilterInput
          key={"search"}
          inputExtraStyle={{ marginBottom: 0 }}
          onChangeText={handleChangeText}
          containerExtraStyle={{
            justifyContent: "flex-start",
          }}
        />
        <div className="w-full mt-5">
          <TableWrapper
            // ref={tableRef}
            isLoading={productLoader}
            thead={[
              "S.No",
              "Product Image",
              "Product Name",
              "Quantity",
              "Action",
            ]}
            page={queryParams.page}
            total={paginated.totalPages}
            columnWidth={"6% 14% 55% 15% 10%"}
            onChange={handlePageChange}
            totalLength={allProducts.length}
            tableBtn={{
              btnText: "Next",
              btnOnClick: () => {
                if (checkProducts()) {
                  setActiveTab("Overview");
                }
              },
            }}
          >
            <div className="tbody-content-height tbody-content-height-allOrder">
              {allProducts?.map((item: IPharmaInventory, index: number) => (
                <ul
                  key={index}
                  className={`font-size-16px tbody-light-table font-Poppins-Regular grid`}
                  style={{
                    gridTemplateColumns: "6% 14% 55% 15% 10%",
                  }}
                >
                  <li>{ (queryParams.page - 1) * queryParams.limit + index + 1}</li>
                  <li>
                    <img
                      src={`${ImageBaseUrl}${item?.images}`}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.src = defaultImage;
                      }}
                      className="w-[30px] h-[30px] object-cover"
                    />
                  </li>
                  <li className="capitalize">{`${item?.productName || ""}`}</li>
                  <li className="flex items-center justify-center w-full">
                    <div className="w-[80px] select-none h-[25px] rounded flex bg-[#00625B]">
                      <div
                        className="w-[25px] h-[25px] text-white flex items-center justify-center cursor-pointer"
                        onClick={() => {
                          let qty = productQuantity[item._id] || 0;
                          qty = qty > 1 ? qty - 1 : qty;
                          setProductQuantity(
                            (prev: { [key: string]: number }) => ({
                              ...prev,
                              [item._id]: qty,
                            })
                          );
                          let isExist = payload.products.find(
                            (product: any) => product._id === item._id
                          );
                          if (isExist) {
                            setPayload((prev: any) => ({
                              ...prev,
                              products: prev.products.map((product: any) =>
                                product._id === item._id
                                  ? {
                                      ...product,
                                      quantity: qty,
                                    }
                                  : product
                              ),
                            }));
                          }
                        }}
                      >
                        -
                      </div>
                      <p className="text-gray-600 bg-white w-[30px] h-[25px] font-Poppins-Regular font-size-14px flex items-center justify-center">
                        {productQuantity[item._id] || 0}
                      </p>
                      <div
                        className="w-[25px] h-[25px] text-white flex items-center justify-center cursor-pointer"
                        onClick={() => {
                          if (productQuantity[item._id] < item?.quantity) {
                            let qty = productQuantity[item._id] || 0;
                            qty = qty + 1;
                            setProductQuantity(
                              (prev: { [key: string]: number }) => ({
                                ...prev,
                                [item._id]: qty,
                              })
                            );
                            let isExist = payload.products.find(
                              (product: any) => product._id === item._id
                            );
                            if (isExist) {
                              setPayload((prev: any) => ({
                                ...prev,
                                products: prev.products.map((product: any) =>
                                  product._id === item._id
                                    ? { ...product, quantity: qty }
                                    : product
                                ),
                              }));
                            }
                          }
                        }}
                      >
                        +
                      </div>
                    </div>
                  </li>
                  <li>
                    <button
                      disabled={item?.quantity === 0}
                      title={item?.quantity === 0 ? "Out of stock" : ""}
                      className="w-[23px] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed h-[23px] border border-gray-600 rounded flex items-center justify-center"
                      onClick={() => {
                        let isExist = payload.products.find(
                          (id: any) => id === item._id
                        );
                        if (isExist) {
                          setPayload((prev: any) => ({
                            ...prev,
                            products: prev.products.filter(
                              (id: any) => id !== item._id
                            ),
                          }));
                        }

                        if (!isExist && item?.quantity > 0) {
                          setPayload((prev: any) => ({
                            ...prev,
                            products: [item?._id, ...prev.products],
                          }));
                        }
                      }}
                    >
                      <FontAwesomeIcon
                        icon={
                          payload.products.includes(item?._id)
                            ? faMinus
                            : faPlus
                        }
                        className="font-size-12px ml-[-2px]"
                      />
                    </button>
                  </li>
                </ul>
              ))}
            </div>
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default OrderAddProduct;
